export const EMAIL_TEMPLATES_SET_SELECTED_PERMISSION_DEPARTMENT = 'EMAIL_TEMPLATES_SET_SELECTED_PERMISSION_DEPARTMENT';
export const EMAIL_TEMPLATES_ADD_PERMISSION_DEPARTMENT = 'EMAIL_TEMPLATES_ADD_PERMISSION_DEPARTMENT';
export const EMAIL_TEMPLATES_ADD_PERMISSION_USER = 'EMAIL_TEMPLATES_ADD_PERMISSION_USER';
export const EMAIL_TEMPLATES_REMOVE_ENTITY_FROM_SELECTION = 'EMAIL_TEMPLATES_REMOVE_ENTITY_FROM_SELECTION';
export const EMAIL_TEMPLATES_SET_PERMISSION_DEPARTMENTS = 'EMAIL_TEMPLATES_SET_PERMISSION_DEPARTMENTS';
export const EMAIL_TEMPLATES_SET_PERMISSION_USERS = 'EMAIL_TEMPLATES_SET_PERMISSION_USERS';


// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/flow/folderPermissionFlow/actionType.js